import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/empty_cart.svg")